module.exports = __webpack_public_path__ + "static/media/logo-aditi.6df10f28.svg";